import React from 'react';
import { NavLink } from 'react-router-dom';
import logoSVG from '../assets/logo.svg';

function Home() {
    return (
        <div className='home-container'>
            <header>
                <div className='logo-container'>
                    <img className='logo-svg' src={logoSVG} alt={'logo'} />
                    <h1><span className='blue'>Box</span>Willet</h1>
                </div>
                <ul className='header-list'>
                    <li className='list-item'>
                        Documentation
                    </li>
                    <li className='list-item'>
                        Pricing
                    </li>
                    <li className='list-item'>
                        <NavLink to='/wallet' className={'anchor'}>
                            <button className='access-btn'>
                                Access Wallet
                            </button>
                        </NavLink>    
                    </li>
                </ul>
            </header>

            <div className='home-body'>
                <ul>
                    <li className='mr-2'>Simple.</li>
                    <li className='mr-2'>Secure.</li>
                    <li className='mr-2'>Seamless.</li>
                </ul>
                <div>
                    <p className='tag-line'>Your Blockchain</p>
                    <p className='tag-line'>Wallet.</p>
                </div>
                <div className='mt-2'>
                    <p><b>Mainstream users' gateway to the decentralized</b></p>
                    <p><b>ecosystem via a login they are familiar with.</b></p>
                </div>
                <button className='solid-btn mt-4'>Get Started</button>
            </div>
        </div>
    )
}

export default Home;